import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import moment from 'moment';
import linkify from 'linkifyjs/html';
import cx from 'classnames';
import AsyncImage from 'common/components/AsyncImage';

// TODO: plug emoji
const formatMessageContent = content => {
  let formatted = '';
  if (content) {
    formatted = linkify(content);
  }

  return {
    __html: formatted,
  };
};

const formatMessageDate = sentAt => moment(sentAt).format('DD/MM/YYYY à H:mm');

const messageClass = message =>
  cx('ui message', {
    me: !message.sender,
  });

class MessageItem extends React.Component {
  static propTypes = {
    message: PropTypes.object.isRequired,
    onImageClick: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.onImageClick = this.onImageClick.bind(this);
  }

  onImageClick() {
    const { message } = this.props;
    this.props.onImageClick(message);
  }

  render() {
    const { message } = this.props;

    return (
      <div className={messageClass(message)}>
        {message.attachment && (
          <AsyncImage
            src={message.attachment.web}
            onClick={this.onImageClick}
          />
        )}
        <p dangerouslySetInnerHTML={formatMessageContent(message.content)} />
        <div className="date">{formatMessageDate(message.sent_at)}</div>
      </div>
    );
  }
}

export default pure(MessageItem);



// WEBPACK FOOTER //
// ./src/modules/messaging/components/MessageItem.js